import React from "react";
import PropTypes from "prop-types";

// styles
import { RootMessageStackZoneStyled } from "./styles";

// components
import MessageList from "./MessageList";

// See Readme about this special component
const RootMessageStackZone = ({ children }) => {
    return (
        <>
            <RootMessageStackZoneStyled>
                <MessageList />
            </RootMessageStackZoneStyled>
            {children}
        </>
    );
};

export default RootMessageStackZone;

// prop-types
RootMessageStackZone.propTypes = {
    children: PropTypes.any.isRequired
};
